module.exports = __webpack_public_path__ + "img/ccic.961736fe.png";